import React, { useState } from 'react';
import { ModalOverlay } from '@moda/om';
import { ContactToPurchaseSuccessMessage } from './ContactToPurchaseSuccessMessage';
import { ContactToPurchaseForm } from './ContactToPurchaseForm';

import './ContactToPurchaseModal.scss';

enum Mode {
  Idle,
  Success
}

type Props = {
  show: boolean;
  onClose: () => void;
};

export const ContactToPurchaseModal: React.FC<Props> = ({ show, onClose }) => {
  const [mode, setMode] = useState(Mode.Idle);

  return (
    <ModalOverlay show={show} onClose={onClose}>
      <div className="ContactToPurchaseModal">
        {mode === Mode.Idle && (
          <ContactToPurchaseForm onClose={onClose} onSuccess={() => setMode(Mode.Success)} />
        )}
        {mode === Mode.Success && <ContactToPurchaseSuccessMessage onClose={onClose} />}
      </div>
    </ModalOverlay>
  );
};
